<template>
  <div class="home">
    <IndicateurTdb class="home__tdb" />
    <cards-layout
      class="home__tasks"
      cardsType="Tâches"
      :cards="cardsListTaches"
    />
    <cards-layout
      v-for="(section, cardType) in homeCardsSubSections"
      :key="cardType"
      class="home__sub-card"
      :cardsType="cardType"
      :cards="section?.cards?.value"
      :redirection="section?.onClick"
    />
  </div>
</template>

<script setup lang="ts">
  import IndicateurTdb from '@/features/interface/home/tableauDeBord/indicateurTdb/IndicateurTdb.vue'
  import CardsLayout from '@/features/interface/home/tableauDeBord/cardsLayout/CardsLayout.vue'
  import { useHomeCardMapping } from './useHomeCardMapping'

  const { homeCardsSubSections, cardsListTaches } = useHomeCardMapping()
</script>

<style scoped lang="less">
  @import './HomeView.less';
</style>
